<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="CredentialForm" @submit.prevent>
        <v-card class="rounded-lg">
          <v-card-title class="d-flex align-center">
            <span>Reset Password</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="pass"
                  :rules="[formRules.required, formRules.password]"
                  label="Password"
                  :color="$vuetify.theme.themes.light.inputColor"
                  :type="showPassword ? 'text' : 'password'"
                  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="showPassword = !showPassword"
                  variant="outlined"
                  density="compact"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";

export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialogConfirmDelete: false,
      showPassword: false,
      dialog: false,

      pass: null,

      btnLoading: false,
      loading: false,
      usertypeList: [],
      userroleList: [],
      user_type: null,
      user_role: [],
      programsList: [],
      institute_id: null,
      instituteList: [],
      selected_institute: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      fetched_data: [],
      removedStudent: [],
    };
  },
  components: {},
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        console.log(data);

        this.$refs.CredentialForm.resetValidation();
      },
      deep: true,
    },
  },
  computed: {},

  mounted() {
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      console.log("vcalled me");
      this.getBatchList();
    });
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentBatchDialog");
  },
  methods: {
    initialize() {},

    async save() {
      let validation = await this.$refs.CredentialForm.validate();

      if (validation.valid) {
        this.btnLoading = true;

        let data = {
          email: this.data.email,
          password: this.pass,
        };
        this.axiosCall("/auth/resetPassword", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = "Reset successful";
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let validation = await this.$refs.ClassSetForm.validate();

      if (validation.valid) {
        this.btnLoading = true;
        let data = {
          batch_id: this.batch_selected,
          student_list: JSON.stringify(this.fetched_data),
          set_name: this.setName,
          program_id: this.program_id,
          removedStudent: JSON.stringify(this.removedStudent),
          group_list_id: this.data.id,
        };
        this.axiosCall("/student/update-set", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeUserManagementDialog", true);
      this.dialog = false;
    },

    getBatchList() {
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
      });
    },

    getAllProgramsByInstitute() {
      this.axiosCall(
        "/program/getAllProgramsByInstitute/" + this.selected_institute,
        "GET",
      ).then((res) => {
        this.programsList = res.data;
      });
    },

    getAllInstitutes() {
      this.axiosCall("/institutes", "GET").then((res) => {
        this.instituteList = res.data;
      });
    },

    getAllUserTypes() {
      if (this.action == "Add") {
        this.usertypeList = [
          {
            id: 3,
            description: "OJT Coordinator",
          },
          {
            id: 4,
            description: "Instructor",
          },
          {
            id: 5,
            description: "Dean",
          },
        ];
      } else {
        this.axiosCall("/user-type/getAllUsertype", "GET").then((res) => {
          this.usertypeList = res.data;
        });
      }
    },

    getAllUserRoles() {
      this.axiosCall("/user-role", "GET").then((res) => {
        console.log(res.data);
        this.userroleList = res.data;
      });
    },
  },
};
</script>
